import { useCallback, useRef } from "react";

export const useChatScroll = () => {
  const chatEndRef = useRef<HTMLDivElement | null>(null);
  const containerRef = useRef<HTMLDivElement | null>(null);

  const scrollToBottom = useCallback((behavior: ScrollBehavior = "smooth") => {
    const container = containerRef.current;
    if (container) {
      container.scrollTo({ top: container.scrollHeight, behavior });
      return;
    }
    // Fallback: scroll apenas o container ancestral do sentinel, nunca a página
    const end = chatEndRef.current;
    if (end && end.parentElement) {
      const parent = end.parentElement;
      parent.scrollTo({ top: parent.scrollHeight, behavior });
    }
  }, []);

  return { scrollToBottom, chatEndRef, containerRef };
};
